<template>
<div class="chapter">
<div class="inner_page">
<p class="timg"><a id="tp"><span class="center"><img alt="image" class="fullpage" src="Art_tit.jpg"/></span></a></p><a id="tp">
</a><p class="cen"><a id="tp"><span class="center"></span></a><a href="http://www.orbitbooks.net" target="_blank">www.orbitbooks.net</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_tp_r1.vue?af9a07ae